import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const PrivateRoute = ({ allowedRoles }) => {
  const user = localStorage.getItem('user');
  let parsedUser = null;

  if (user) {
    try {
      parsedUser = JSON.parse(user);
    } catch (error) {
      console.error('Error parsing user data:', error);
      return <Navigate to="/login" />;
    }
  }

  if (!parsedUser) {
    return <Navigate to="/login" />;
  }

  if (allowedRoles && !allowedRoles.includes(parsedUser.role)) {
    return <Navigate to="/login" />;
  }

  return <Outlet />;
};

export default PrivateRoute;